<!-- https://8es9hr.axshare.com/#p=%E7%90%86%E4%BA%8B%E6%9C%83%E5%AF%A9%E6%9F%A5_3&g=1 -->
<!-- 理事會審查-->
<template>
    <div>
        <ListForm
            :id="id"
            :recordToEdit="recordToEdit"
            :formType="formType"
            :rules="rules"
            :api="api"
            @formCB="formCB"
            labelPosition="top"
            formTitle="理事會審查紀錄"
            action="submitCouncilResult"
            ref="formSave"
        >
            <div class="dialog-footer" slot="footer">
                <el-button
                    plain
                    type="primary"
                    @click="submit"
                    v-if="recordToEdit && recordToEdit.councilAuditStatus == 0"
                >通過並送出</el-button>
                <el-button
                    plain
                    type="danger"
                    class="mr10"
                    @click="rejectCouncilResult"
                    v-if="recordToEdit && recordToEdit.councilAuditStatus == 0"
                >拒絕轉入</el-button>
                <el-button plain @click="back">返回</el-button>
            </div>
        </ListForm>
    </div>
</template>

<script>
import ListForm from "@/components/ListForm.vue";
import { API } from "@/assets/config";

export default {
    name: "transfer_in_council_review",
    components: { ListForm },
    props: {
        reviewInfo: {
            type: Object,
            default() {
                return {};
            }
        },
        enumData: {
            type: Object,
            default() {
                return {};
            }
        },
        upperRecordToEdit: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            id: this.$route.params.id,
            api: "memberTransferCoopInApply",
            recordToEdit: {},
            formType: [
                {
                    label: "審查日期",
                    key: "councilAuditDate",
                    type: "date",
                    require: true
                },

                {
                    label: "理事會審查紀錄",
                    key: "meetingRcdId",
                    type: "select",
                    options: [],
                }
            ],
            rules: {
                councilAuditDate: [
                    {
                        required: true,
                        message: "請選擇審查日期",
                        trigger: "change"
                    }
                ],
            }
        };
    },
    created() {
        this.reviewData();
    },
    watch: {
        upperRecordToEdit: {
            handler(key) {
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.recordToEdit = this.upperRecordToEdit;
                    }, 200);
                });
            },
            deep: true
        },
        enumData: {
            handler(key) {
                this.$nextTick(() => {
                    setTimeout(() => {
                        // 審查結果
                        this.formType[1].options = this.enumData.workFlowStatus;
                        // 理事會審查紀錄
                        this.formType[1].options = this.enumData.meetingRcd;
                    }, 200);
                });
            },
            deep: true
        }
    },
    methods: {
        reviewData() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.recordToEdit = this.reviewInfo.reviewInfo;
                }, 200);
            });
        },
        submit() {
            this.$refs.formSave.submitForm("recordToEdit");
        },
        back() {
            this.$router.push({ name: "transfer_in" });
        },
        formCB() {
            this.$parent.getData();
        },
        go(name, id) {
            this.$router.push({
                name: `${name}`,
                params: {
                    id: id
                }
            });
        },
        /**
         * 拒絕轉入，須一併送出審查日期與會議紀錄，作業流程頁才顯示得出日期
         */
        async rejectCouncilResult() {
            // 拒絕不走 ListForm.submit，必填欄位需要自行檢查
            if (!this.recordToEdit.councilAuditDate) {
                this.$message.error("請選擇審查日期");
                return;
            }

            let url = API[this.api] + `?action=rejectCouncilResult`;
            const form = new FormData();
            form.append("id", this.id);
            // 取日期部分，避免時間影響
            form.append(
                "councilAuditDate",
                this.recordToEdit.councilAuditDate.split(" ")[0]
            );
            form.append("meetingRcdId", this.recordToEdit.meetingRcdId || "");
            try {
                await this.mAxiosPost(url, form);
                this.showAjaxSuccessMsg();
                this.$parent.getData();
            } catch (error) {
                //錯誤訊息已由 mAxiosPost 顯示，這裡只接住 reject
            }
        }
    }
};
</script>
